const initialState = { 
    graphData: []
}

const graphReducer = (state = initialState, action) => {
    switch(action.type) {
        case 'ADD_GRAPH_DATA':
            return {
                ...state,  //append to current redux state
                graphData: [...state.graphData, action.payload] //input payload to redux state
            }

            case 'CLEAR_GRAPH_DATA':
            return {
                ...state,  //append to current redux state
                graphData: [] //input payload to redux state
            }

            default:
                return state;
    }
} 
export default graphReducer;
